<h3 class="mg-step-header">
  <ng-container>
    {{ estimateConfirmLabels.transactionDetails }}
  </ng-container>
</h3>

<div class="currency-deposit">
  <div class="deposit-amount-currency" *ngIf="flow === 'deposit'">
    <h2 class="currency-label">{{ estimateConfirmLabels.depositAmount }}</h2>
    <h1 class="currency-value">{{ totalUSDCAmount }} USDC</h1>
  </div>
  <div class="deposit-amount-currency" *ngIf="flow === 'withdraw'">
    <h2 class="currency-label">{{ estimateConfirmLabels.withdrawalAmount }}</h2>
    <h1 class="currency-value">{{ totalUSDCAmount }} USDC</h1>
  </div>
  <div class="glob-flag flag"></div>
</div>

<app-summary-section
  [items]="summarySectionConfig?.items!"
  [title]="summarySectionConfig?.title!"
>
</app-summary-section>

<div class="estimate-totals-container">
  <div class="estimate-total-row" *ngIf="flow === 'withdraw'">
    <h4 class="bold-text mat-body">
      <ng-container> {{ estimateConfirmLabels.cashOutAmount }}: </ng-container>
    </h4>
    <p class="bold-text mat-body">{{ totalAmountToPay }} {{ currency }}</p>
  </div>
  <div class="estimate-total-row" *ngIf="flow === 'deposit'">
    <h4 class="bold-text mat-body">
      {{ estimateConfirmLabels.amountToPay }}
    </h4>
    <p class="bold-text mat-body">
      {{ payOutAtLocation }} {{ payOutAtLocationCurrency }}
    </p>
  </div>
  <!-- TODO: exchange rate component -Hamza -->
  <!-- <app-exchange-rate  *ngIf="exchangeRate" 
                      [flow]="flow"
                      [currency]="currency"
                      [exchangeRate]="exchangeRate"
                      [label]="estimateConfirmLabels"
  >
  </app-exchange-rate> -->
</div>
<app-indicative-rate-note></app-indicative-rate-note>
<div *ngIf="locationFinderService.selectedBranch">
  <app-location-search-detail
    [flow]="flow"
    [labels]="locationLabels"
    [pinSelectedLocation]="locationFinderService.selectedBranch ? true : false"
    (back)="onBack()"
  ></app-location-search-detail>
</div>
<app-terms-and-conditions
  [flow]="flow"
  [labels]="labels"
  [locale]="locale"
></app-terms-and-conditions>
<div class="mg-step-actions-row">
  <app-moneygram-locations-link
    [google]="google"
    [kind]="flow"
    [labels]="labels"
    [displaySuperscript]="true"
  ></app-moneygram-locations-link>
  <app-walmart-footnote
    *ngIf="flow === 'withdraw'"
    [labels]="labels"
  ></app-walmart-footnote>
  <button color="primary" mat-raised-button (click)="confirmFees()">
    {{ labels.stellar.confirm }}
  </button>
</div>
